import React from "react";

const C = {
  teal: "#008fa0",
  tealLight: "#e6f4f6",
  text: "#0d2226",
  textMuted: "#64748b",
  sans: '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

const TableLoader = ({
  message = "Chargement des données en cours...",
  subMessage = "Veuillez patienter quelques instants",
  minHeight = "280px",
  style = {},
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        padding: "40px 20px",
        fontFamily: C.sans,
        width: "100%",
        ...style,
      }}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          border: `3px solid ${C.tealLight}`,
          borderTop: `3px solid ${C.teal}`,
          borderRadius: "50%",
          animation: "easyComptaSpin 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite",
          marginBottom: "16px",
        }}
      />
      <div
        style={{
          fontSize: "15px",
          fontWeight: 600,
          color: C.text,
          marginBottom: "4px",
          textAlign: "center",
          letterSpacing: "0.2px",
        }}
      >
        {message}
      </div>
      {subMessage && (
        <div
          style={{
            fontSize: "12px",
            color: C.textMuted,
            textAlign: "center",
          }}
        >
          {subMessage}
        </div>
      )}
      <style>{`
        @keyframes easyComptaSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default TableLoader;
